import { EventType } from '../EventType';
import { ApplicationEvent } from '../GameEvent';
export class StartAutoPlayEvent extends ApplicationEvent {
    constructor(autoplayMinutes) {
        super();
        this.autoplayMinutes = autoplayMinutes;
        this.eventType = EventType.START_AUTOPLAY;
    }
}
